import React from "react";
import { Link } from 'react-router-dom';
import Icon from "../../assets/favicon4-4.png";
export default function Footer() {
  return (
    <footer class="bg-white pt-12 pr-0 pb-1.5 pl-0 border-t border-gray-200">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div class="flex items-center space-x-4 space-x-reverse mb-6">
              <div class="logo-container">
                <img src={Icon} alt="هوش جدید" />
              </div>
              <div class="flex flex-col">
                <span class="text-xl font-bold text-black ">هوش جدید</span>
              </div>
            </div>
            <p class="text-gray-600 mb-6 leading-relaxed">
              هوش جدید فقط آموزش برنامه‌نویسی نیست؛
               پلتفرمی است برای تصمیم‌سازی و طراحی مسیر حرفه‌ای توسعه‌دهندگان با تمرکز بر 
               JavaScript، React، Node.js، پایتون و وردپرس.
            </p>
            <div class="flex space-x-4 space-x-reverse">
              <a
                href="https://wa.me/989331187978?text=با+سلام+ از+ طرف + سایت +هوش جدید + پیام+ میفرستم"
                class="w-10 h-10 bg-primary rounded-lg flex items-center justify-center text-white hover:bg-dark transition-colors"
              >
                <i className="text-lg fab fa-whatsapp"></i>
              </a>
              <a
                href="http://instagram.com/tarahe.website"
                class="w-10 h-10 bg-primary rounded-lg flex items-center justify-center text-white hover:bg-dark transition-colors"
              >
                <i className="text-lg fab fa-instagram"></i>
              </a>
              <a
                href="https://t.me/WebsiteDeveloper"
                class="w-10 h-10 bg-primary rounded-lg flex items-center justify-center text-white hover:bg-dark transition-colors"
              >
                <i className="text-lg fab fab fa-telegram-plane"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 class="text-lg font-bold text-dark mb-6">لینک‌های سریع</h3>
            <ul class="space-y-3">
              <li>
                <Link to="/" class="text-gray-600 hover:text-primary transition-colors">
                  خانه
                </Link>
              </li>
              <li>
                <Link to="/courses" class="text-gray-600 hover:text-primary transition-colors">
                  دوره‌های آموزشی
                </Link>
              </li>
              <li>
                <Link to="/blog" class="text-gray-600 hover:text-primary transition-colors">
                  مقالات تخصصی
                </Link>
              </li>
              <li>
                <Link to="/consultation" class="text-gray-600 hover:text-primary transition-colors">
                  مشاوره تخصصی
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 class="text-lg font-bold text-dark mb-6">دوره‌های محبوب</h3>
            <ul class="space-y-3">
              <li>
                <Link to="/courses/2" class="text-gray-600 hover:text-primary transition-colors">
                  مستر پلاس وردپرس
                </Link>
              </li>
              <li>
                <Link to="/courses/3" class="text-gray-600 hover:text-primary transition-colors">
                  اصول برنامه سازی
                </Link>
              </li>
              <li>
                <Link to="#" class="text-gray-600 hover:text-primary transition-colors">
                  آموزش JavaScript
                </Link>
              </li>
              <li>
                <Link to="#" class="text-gray-600 hover:text-primary transition-colors">
                  آموزش هوش مصنوعی
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 class="text-lg font-bold text-dark mb-6">تماس با ما</h3>
            <div class="space-y-3">
              <p class="text-gray-600 flex items-center">
                <span class="text-primary ml-2">📧</span>
                info@hooshjadid.ir
              </p>
              <p class="text-gray-600 flex items-center">
                <span class="text-primary ml-2">📱</span>
                083-37223368
              </p>
              <p class="text-gray-600 flex items-center">
                <span class="text-primary ml-2">📍</span>
                کرمانشاه، خیابان دبیر اعظم، مجتمع تجاری کامپیوتری میرداماد، طبقه
                دوم، واحد 114
              </p>
            </div>

            {/* نماد اعتماد الکترونیکی */}
            <div className="mt-6">
              <a
                referrerPolicy="origin"
                target="_blank"
                href="https://trustseal.enamad.ir/?id=682859&Code=5WBbdpMm31C5rX8v2rujqgA3Cu5pNW1a"
              >
                <img
                  referrerPolicy="origin"
                  src="https://trustseal.enamad.ir/logo.aspx?id=682859&Code=5WBbdpMm31C5rX8v2rujqgA3Cu5pNW1a"
                  alt="نماد اعتماد الکترونیک"
                  style={{ cursor: "pointer" }}
                  code="5WBbdpMm31C5rX8v2rujqgA3Cu5pNW1a"
                />
              </a>
            </div>
          </div>
        </div>

        <div class="border-t border-gray-200 mt-12  text-center">
          <p class="text-black-600 text-sm p-3">
            هوش جدید، تمامی حقوق برای تیم مصعب محفوظ است. &copy; 1404-1405
          </p>
        </div>
      </div>
    </footer>
  );
}
